<template>
  <div
    id="detail-summay-content"
    class="detail-summay-containter"
  >
    <ul
      id="detail-summay-accordion"
      class="accordion"
      data-accordion
      data-deep-link="true"
      data-allow-all-closed="true"
      data-multi-expand="true"
      data-update-history="true"
      data-deep-link-smudge="500"
    >
      <li
        class="accordion-item is-active"
        data-accordion-item
      >
        <a
          href="#detail-summary-tabs"
          class="accordion-title"
        >
          <span>{{ $t('tender.detail') }}</span>
        </a>
        <div
          id="detail-summary-tabs"
          class="accordion-content"
          data-tab-content
        >
          <div class="row detail-options">
            <HKLSelect
              class="item-selector column small-5"
              :value="viewUser ? viewUser.id : undefined"
              :options="viewUserHklOptions"
              :showSearch="false"
              placeholder=""
              @change="onViewUserChange"
            />
            <div class="column small-4 tender-detail-btns">
              <div class="row align-right">
                <ExportPdfWithOptions
                  v-if="shouldShowExportPdf"
                  :options="exportOptions"
                  @export:pdf="val => exportPDF(val)"
                />
                <button
                  v-show="showQueryBtn"
                  role="start-query-button"
                  type="button"
                  class="btn btn--darkblue"
                  @click="startQuery()"
                >
                  {{ $t('action.startQuery') }}
                </button>
              </div>
            </div>
          </div>
          <div id="detail-list">
            <tender v-show="viewUser&&viewUser.isEngineer" />
            <bid
              v-if="showBid"
              ref="bidComponent"
            />
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { exportBlankTenderBid } from '@/api/printers/request'
import ExportPdfWithOptions from '@/controls/ExportPdfWithOptions'
import HKLSelect from '@/controls/Select/HKLSelect.vue'
import Bid from '@/modules/tenders/review/detail/Bid.vue'
import Tender from '@/modules/tenders/review/detail/Tender'
import { utils as formUtils } from '@/plugin/InputChange'
import mutationTypes from '@/store/mutation-types'
import { FORM_SRC_TENDER_QUERY } from '@/utils/consts'
import EventBus from '@/utils/eventBus'
import { queryStatus, tenderStatus, vendorBidStatus } from '@/utils/locale'
import lodash from 'lodash'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { aclHelper, aclPermsType } from '@/utils/aclHelper'

export default {
  components: {
    HKLSelect,
    Tender,
    ExportPdfWithOptions,
    Bid,
  },
  props: {
    tenderId: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      username: 'Sherry',
      componentName: '',
      viewUser: null,
      tmpViewUser: null,
      showBid: false,
      bidId: '',
      exportLabel: null,
    }
  },
  computed: {
    ...mapGetters('tenders', ['currentTender', 'currentBid', 'currentBidId', 'isPicView', 'isRepresentative']),
    ...mapGetters('form', ['dirtyComponents']),
    ...mapGetters('user', ['currentUser']),

    currentTenderId () {
      return this.currentTender.general.id
    },
    defaultViewOption () {
      return {
        name: this.$t('user.engineer'),
        id: this.currentTenderId,
        isEngineer: true,
      }
    },
    options () {
      const options = [this.defaultViewOption]
      const enabledStatus = [tenderStatus.REVIEW, tenderStatus.AWARDED, tenderStatus.REGRETTED]
      const isEnabledStatus = enabledStatus.includes(this.currentTender.general.status)
      if (isEnabledStatus && this.currentTender.bids) {
        this.currentTender.bids.forEach((rec) => {
          if (rec.status === vendorBidStatus.SUBMITTED) {
            options.push({
              name: lodash.get(rec, 'company.name') || '',
              id: rec.id,
            })
          }
        }, this)
      }
      return options
    },
    showBtnForBid () {
      return this.viewUser && !this.viewUser.isEngineer
    },
    shouldShowExportPdf () {
      const curStatus = this.currentTender.general.status
      const isPicOrTenderRep = this.isPicView || this.isRepresentative
      const allowedPicOrTenderRepStatus = [tenderStatus.ISSUED, tenderStatus.READY, tenderStatus.REVIEW].includes(curStatus)
      const hasReadAccess = aclHelper.getAccess(aclPermsType.tenders.read)
      const allowedReadAccessStatus = tenderStatus.AWARDED === curStatus
      return this.showBtnForBid || (isPicOrTenderRep && allowedPicOrTenderRepStatus) || (hasReadAccess && allowedReadAccessStatus)
    },
    hasOpenQuery () {
      if (!(deep(this.currentBid, 'queries.length') > 0)) return false
      return this.currentBid.queries.some(query => [queryStatus.DRAFT, queryStatus.ISSUED].includes(query.status))
    },

    showQueryBtn () {
      if (!this.showBtnForBid || !(this.isPicView || this.isRepresentative)) return false
      let showQueryBtn = false
      if (tenderStatus.REVIEW === this.currentTender.general.status && this.currentBid) {
        showQueryBtn = true
        if (this.currentBid.id === this.viewUser.id && this.hasOpenQuery) {
          showQueryBtn = false
        }
      }
      return showQueryBtn
    },

    exportOptions () {
      let exportOptions = [`${this.$i18n.t('bid')} ${this.$i18n.t('summary.name')}`]
      if (deep(this.currentBid, 'queries.length') > 0) {
        exportOptions.push(`${this.$i18n.t('tender.query.name')} ${this.$i18n.t('summary.name')}`)
      }
      return exportOptions
    },
    viewUserHklOptions () {
      return this.options.map((opt) => ({
        name: opt.name,
        value: opt.id,
      }))
    },
  },
  watch: {
    async viewUser () {
      if (this.viewUser) {
        this.showBid = false
        await this.timeout(0)
        this.showBid = this.viewUser && !this.viewUser.isEngineer
        this.bidId = this.viewUser && this.viewUser.id
        if (this.viewUser && !this.viewUser.isEngineer) {
          this.setBidId({ id: this.viewUser.id })
        }
      }
    },
  },
  async mounted () {
    if (!this.summaryAccordion) {
      this.summaryAccordion = new Foundation.Accordion(($('#detail-summay-accordion')))
    }
    await this.selectChange(this.viewUser)
    EventBus.$on(`component_confirm_continue_${FORM_SRC_TENDER_QUERY}`, () => {
      this.selectChange(this.tmpViewUser, false)
    })
    this.viewUser = this.defaultViewOption
  },
  destroyed () {
    if (this.summaryAccordion) {
      this.summaryAccordion.destroy()
    }
    this.setBidId({ id: null })
    this.setCurrentBid({ bid: {} })
    EventBus.$off(`component_confirm_continue_${FORM_SRC_TENDER_QUERY}`)
  },

  methods: {
    ...mapMutations('tenders', {
      setBidId: mutationTypes.TENDER_CURRENT_BID_ID,
      setCurrentBid: mutationTypes.TENDER_SET_CURRENT_BID,
    }),
    ...mapActions('tenders', ['refreshCurrentBid']),

    timeout (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },

    async setSelectedView (selectedView) {
      const tmp = selectedView
      this.viewUser = null
      await this.timeout(0)
      this.viewUser = tmp
    },

    onViewUserChange (id) {
      const selectedView = this.options.find((opt) => opt.id === id)
      this.selectChange(selectedView)
    },

    async selectChange (selectedView, checkDirty = true) {
      if (checkDirty && this.dirtyComponents[FORM_SRC_TENDER_QUERY]) {
        this.tmpViewUser = selectedView
        await this.setSelectedView(this.viewUser)
        EventBus.$emit('modules_confirm_continue_do_nav', {src: FORM_SRC_TENDER_QUERY})
        return
      }
      formUtils.resetDirty(FORM_SRC_TENDER_QUERY)

      await this.setSelectedView(selectedView)
      if (this.viewUser && this.viewUser.isEngineer) {
        this.setBidId({ id: null })
        this.setCurrentBid({ bid: {} })
      }
    },
    async exportPDF (selectedExport) {
      if (this.viewUser.isEngineer) {
        await exportBlankTenderBid(this.currentTender)
      } else {
        await this.$refs.bidComponent.exportPDF(selectedExport)
      }
      this.exportLabel = null
    },
    async startQuery () {
      await this.refreshCurrentBid()
      const tmp = this.viewUser
      if (!this.hasOpenQuery) {
        await this.$refs.bidComponent.startQuery()
      } else {
        $('#bid-tabs').foundation('selectTab', '#bid-tab-query', false)
      }
      EventBus.$emit('refresh:tender-query')
      this.viewUser = tmp
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/accordion';
#detail-summay-content{
  background: white;
  background-clip: content-box;

  #detail-summay-accordion {
    max-width: 1440px;
    margin: 0 auto;
  }
  .accordion-item {
    background: white;
  }

  .accordion-title {
    font-family: Georgia;
    background-color: white;
    border: 0;
    border-bottom: 1px solid #e0e0e0;
  }

  .accordion-content {
    background: transparent;
    border: 0;
    padding: 22px 0 0 0;
  }

}

.detail-options {
   width: auto;
   margin-left: 24px;
   margin-right: 24px;
   justify-content: space-between;
}

.tender-detail-btns {
  float: right;
  width: auto;
  button {
    margin-bottom: 0;
    &:nth-of-type(1) {
      margin-left: 12px;
    }
  }
  .export {
    width: auto;
    margin-right: 10px;
    border: solid 1px #B5B5B5;

    .text {
      padding: 6px 1px 6px 10px;
      margin: 0;
      color: #0C3A58;
    }
  }
}
</style>

<style lang="scss">
.detail-summay-containter {
  .create-tender-main .hkld-tabs.tabs {
    background: #f8f8f8;
  }
}

.item-selector {
  width: 550px;
}
</style>
